/**
 * Billing API — fetches Zoho subscription and invoice data.
 *
 * Stored procedures:
 *   getzohosubscription  → subscription info for the campus (may return multiple)
 *   getzohoinvoices      → invoice list for the campus
 */

import { apiFetch } from '../../../services/api.js';
import { getCampusGuid } from '../../../services/session.js';
import { MOCK_SUBSCRIPTIONS, MOCK_INVOICES } from '../data/mockData.js';

/** Set to false when the API endpoints are ready */
const USE_MOCK = false;

/**
 * Fetch all subscriptions for the current campus.
 * @returns {Promise<Array>} Array of subscription objects
 */
export async function fetchSubscriptions() {
  if (USE_MOCK) return MOCK_SUBSCRIPTIONS;
  const rows = await apiFetch({
    reqType: 'stored',
    procedure: 'getzohosubscription',
    pKey: 'campus_id',
    pVal: getCampusGuid(),
  });
  return rows || [];
}

/**
 * Fetch invoices for the current campus.
 * @returns {Promise<Array>} Array of invoice objects
 */
export async function fetchInvoices() {
  if (USE_MOCK) return MOCK_INVOICES;
  return await apiFetch({
    reqType: 'stored',
    procedure: 'getzohoinvoices',
    pKey: 'campus_id',
    pVal: getCampusGuid(),
  });
}
